import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import PriceListTreeView from './priceListTreeView'
import {partsPivotTableKey} from 'reducers/priceListsContext/parts'
import {getTotalRowCount} from 'selectors/pivotTable'
import {getTaxCodes} from 'selectors/data'
import {getHeaderHeight} from 'selectors/ui'
import {skillPage} from "actions/onboarding"
import {deSelectAllRows, requestData} from 'actions/pivotTable'
import {showMovePartCategoryDialog} from 'actions/dialog'
import {
  getExpandedCategories,
  getPartCategories,
  getPartTemplates,
  isPartCategoryDetailsExpanded,
} from 'selectors/priceLists'
import {
  checkDeletePartCategory,
  collapseCategory,
  expandCategory,
  loadPartCategories,
  selectCategory,
  selectPriceList,
  showAddPriceListDialog,
  showPartCategoryDialog,
  toggleCategoryDetails,
} from 'actions/priceLists'

const mapStateToProps = (state, ownProps) => {
  const {categoryId, priceListId} = state.priceListsContext.parts

  return {
    expandedCategories: getExpandedCategories(state),
    partCategories: getPartCategories(state),
    categoryId: categoryId || ownProps.categoryId,
    priceListId: priceListId || ownProps.priceList,
    totalParts: getTotalRowCount(state, partsPivotTableKey),
    taxCodes: getTaxCodes(state),
    partTemplates: getPartTemplates(state),
    headerHeight: getHeaderHeight(state),
    isInAddPartSkill: state.onboarding.skills.ADD_PART.active,
    isPartCategoryDetailsExpanded: isPartCategoryDetailsExpanded(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onExpand: (key) => dispatch(expandCategory(key)),
    onCollapse: (key) => dispatch(collapseCategory(key)),
    onShowMovePartCategoryDialog: (category) => dispatch(showMovePartCategoryDialog(category)),
    onShowDeletePartCategoryDialog: (category) => dispatch(checkDeletePartCategory(category)),
    onShowPartCategoryDialog: (category, isEditing = false) => dispatch(showPartCategoryDialog(category, isEditing)),
    onSelectCategory: (category, forwardNav, partCategories) => {
      dispatch(selectCategory(category, forwardNav, partCategories))
    },
    onSelectPriceList: (priceListId) => dispatch(selectPriceList(priceListId)),
    onDeSelectAllRows: () => dispatch(deSelectAllRows(partsPivotTableKey)),
    onLoadParts: () => dispatch(requestData(partsPivotTableKey)),
    onLoadPartCategories: () => dispatch(loadPartCategories()),
    onShowAddPriceListDialog: () => dispatch(showAddPriceListDialog()),
    onSkillPage: (skill, page) => dispatch(skillPage(skill, page)),
    onToggleCategoryDetails: (isPartCategoryDetailsExpanded) => {
      dispatch(toggleCategoryDetails(isPartCategoryDetailsExpanded))
    },
  }
}

const PriceListTreeViewContainer = connect(mapStateToProps, mapDispatchToProps)(PriceListTreeView)

export default withRouter(PriceListTreeViewContainer)
